import React, { useContext } from 'react';
import { ProductContext } from '../../ProductProvider';
import "../../../node_modules/bootstrap/dist/js/bootstrap.min.js";
import { Link, useNavigate } from 'react-router-dom';
import { RoutesLocal } from '../../routes';
import { signOut } from 'aws-amplify/auth';
import { useSnackbar } from 'notistack';
import logo from '../../assets/images/logo/arlogo.png';


export default function Header() {
  const { loggedUser, setIsSidebarOpen, isSidebarOpen, setLoggedUser} = useContext(ProductContext);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const displayName = loggedUser?.name || loggedUser?.email || 'Admin';
  const profileLabel = loggedUser?.profile || 'Portal access';

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleSignOut=async(event)=>{
      event.preventDefault();
      //console.log("inside sighout");
      try{
         await signOut()
         .then((res)=>{
          //  setIsSidebarOpen(true);
           // setCssClass('content_fullscreen');
          setLoggedUser({...loggedUser,
            name:'',
            email:'',
           // currentStatus:'',
            DOB:'',
            profile:'',
            provinceName:'',
            website:'',
            isAuthenticated:false
          }); 
          enqueueSnackbar("Logged Out Successfully",{variant : 'success'});
          navigate(RoutesLocal.Signin.path);
  
        }).catch((error)=>{
         enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
        })
      }catch(error){
         enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
      }
    }

  return (
    <div>
    <header id="header" className="header fixed-top d-flex align-items-center header-shell">
      <div className="header-brand">
        <a href="archivesj.in" className="logo d-flex align-items-center header-brand__link" style={{textDecoration:"none"}}>
          <span className="header-brand__logo-wrap">
            <img src={logo} alt="Archive logo" className="welcome-avatar header-brand__logo"/>
          </span>
            <span className="school-name-modern header-brand__title">ARCHIVE</span>
                    </a>
      </div>

      <button
        type="button"
        className="header-toggle"
        onClick={toggleSidebar}
        aria-label="Toggle sidebar"
        aria-pressed={isSidebarOpen}
      >
        <i className="bi bi-list"></i>
      </button>
 <span className="d-none d-lg-flex header-brand__copy">
            <span className="school-name-modern header-brand__title">ARCHIVE</span>
            <span className="header-brand__subtitle school-name-modern header-brand__title">Admin Portal</span>
          </span>
           <div className="header-status d-none d-lg-inline-flex">
          <span className="header-status__dot" aria-hidden="true"></span>
          <span>Live dashboard</span>
        </div>
          
     {/*} <div className="header-quick-copy d-none d-md-flex">
        <span className="header-quick-copy__eyebrow">Welcome back</span>
        <strong>{displayName}</strong>
      </div>*/}

     {/*} <div className="search-bar">
        <form className="search-form d-flex align-items-center" method="POST" action="#">
          <input type="text" name="query" placeholder="Search" title="Enter search keyword"/>
          <button type="submit" title="Search"><i className="bi bi-search"></i></button>
        </form>
      </div>*/}

      <nav className="header-nav ms-auto header-actions">
        <ul className="d-flex align-items-center">

          {/*}<li className="nav-item d-block d-lg-none">
            <a className="nav-link nav-icon search-bar-toggle " href="#">
              <i className="bi bi-search"></i>
            </a>
          </li>

          <li className="nav-item dropdown">

            <a className="nav-link nav-icon" href="#" data-bs-toggle="dropdown">
              <i className="bi bi-bell"></i>
              <span className="badge bg-primary badge-number">4</span>
            </a>

            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications">
              <li className="dropdown-header">
                You have 4 new notifications
                <a href="#"><span className="badge rounded-pill bg-primary p-2 ms-2">View all</span></a>
              </li>
              <li>
                <hr className="dropdown-divider"/>
              </li>

              <li className="notification-item">
                <i className="bi bi-exclamation-circle text-warning"></i>
                <div>
                  <h4>Lorem Ipsum</h4>
                  <p>Quae dolorem earum veritatis oditseno</p>
                  <p>30 min. ago</p>
                </div>
              </li>

              <li>
                <hr className="dropdown-divider"/>
              </li>

              <li className="notification-item">
                <i className="bi bi-x-circle text-danger"></i>
                <div>
                  <h4>Atque rerum nesciunt</h4>
                  <p>Quae dolorem earum veritatis oditseno</p>
                  <p>1 hr. ago</p>
                </div>
              </li>

              <li>
                <hr className="dropdown-divider"/>
              </li>

              <li className="notification-item">
                <i className="bi bi-check-circle text-success"></i>
                <div>
                  <h4>Sit rerum fuga</h4>
                  <p>Quae dolorem earum veritatis oditseno</p>
                  <p>2 hrs. ago</p>
                </div>
              </li>

              <li>
                <hr className="dropdown-divider"/>
              </li>

              <li className="notification-item">
                <i className="bi bi-info-circle text-primary"></i>
                <div>
                  <h4>Dicta reprehenderit</h4>
                  <p>Quae dolorem earum veritatis oditseno</p>
                  <p>4 hrs. ago</p>
                </div>
              </li>

              <li>
                <hr className="dropdown-divider"/>
              </li>
              <li className="dropdown-footer">
                <a href="#">Show all notifications</a>
              </li>

            </ul>

          </li>

          <li className="nav-item dropdown">

            <a className="nav-link nav-icon" href="#" data-bs-toggle="dropdown">
              <i className="bi bi-chat-left-text"></i>
              <span className="badge bg-success badge-number">3</span>
            </a>

            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow messages">
              <li className="dropdown-header">
                You have 3 new messages
                <a href="#"><span className="badge rounded-pill bg-primary p-2 ms-2">View all</span></a>
              </li>
              <li>
                <hr className="dropdown-divider"/>
              </li>

              <li className="message-item">
                <a href="#">
                  <img src="assets/img/messages-1.jpg" alt="" className="rounded-circle"/>
                  <div>
                    <h4>Maria Hudson</h4>
                    <p>Velit asperiores et ducimus soluta repudiandae labore officia est ut...</p>
                    <p>4 hrs. ago</p>
                  </div>
                </a>
              </li>
              <li>
                <hr className="dropdown-divider"/>
              </li>

              <li className="message-item">
                <a href="#">
                  <img src="assets/img/messages-2.jpg" alt="" className="rounded-circle"/>
                  <div>
                    <h4>Anna Nelson</h4>
                    <p>Velit asperiores et ducimus soluta repudiandae labore officia est ut...</p>
                    <p>6 hrs. ago</p>
                  </div>
                </a>
              </li>
              <li>
                <hr className="dropdown-divider"/>
              </li>

              <li className="message-item">
                <a href="#">
                  <img src="assets/img/messages-3.jpg" alt="" className="rounded-circle"/>
                  <div>
                    <h4>David Muldon</h4>
                    <p>Velit asperiores et ducimus soluta repudiandae labore officia est ut...</p>
                    <p>8 hrs. ago</p>
                  </div>
                </a>
              </li>
              <li>
                <hr className="dropdown-divider"/>
              </li>

              <li className="dropdown-footer">
                <a href="#">Show all messages</a>
              </li>

            </ul>

          </li>*/}

          <li className="nav-item dropdown pe-3">

            <button className="nav-link nav-profile d-flex align-items-center pe-0 header-user" type="button" data-bs-toggle="dropdown" aria-expanded="false">
              <span className="header-user__avatar">
                <img src={logo} alt="Profile" className="rounded-circle"/>
              </span>
              <span className="d-none d-md-block dropdown-toggle ps-2 header-user__name">{displayName}</span>
            </button>

            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
              <li className="dropdown-header">
                <h6>{displayName}</h6>
                <span>{profileLabel}</span>
              </li>
              <li>
                <hr className="dropdown-divider"/>
              </li>

              <li>
                <Link className="dropdown-item d-flex align-items-center" to={RoutesLocal.MyProfile.path}>
                  <i className="bi bi-person"></i>
                  <span>My Profile</span>
                </Link>
              </li>
              <li>
                <hr className="dropdown-divider"/>
              </li>

             {/*} <li>
                <a className="dropdown-item d-flex align-items-center" href="users-profile.html">
                  <i className="bi bi-gear"></i>
                  <span>Account Settings</span>
                </a>
              </li>
              <li>
                <hr className="dropdown-divider"/>
              </li>

              <li>
                <a className="dropdown-item d-flex align-items-center" href="pages-faq.html">
                  <i className="bi bi-question-circle"></i>
                  <span>Need Help?</span>
                </a>
              </li>
              <li>
                <hr className="dropdown-divider"/>
              </li>*/}

              <li>
                <a className="dropdown-item d-flex align-items-center" href="#" onClick={handleSignOut}>
                  <i className="bi bi-box-arrow-right"></i>
                  <span>Sign Out</span>
                </a>
              </li>

            </ul>
          </li>

        </ul>
      </nav>

</header>

    </div>
  )
}
